import { CloudDeliveryPromiseType } from "@omni/types/api/product/cloud/shared/enums/deliveryPromiseType.enum";
import { CloudStockLevel } from "@omni/types/api/product/cloud/shared/enums/stockLevel.enum";
import { CloudProductAvailability } from "@omni/types/api/store/cloud/shared/productAvailability.model";

export const hasNoStock = (
    realTimeStockAvailable?: boolean,
    stockLevel?: CloudStockLevel | null,
    realTimeStock?: number
) => {
    return (
        (!realTimeStockAvailable && stockLevel === null) ||
        (!realTimeStockAvailable && stockLevel === CloudStockLevel.NoStock) ||
        (!realTimeStockAvailable &&
            stockLevel === CloudStockLevel.UnknownStock) ||
        (realTimeStockAvailable && realTimeStock! <= 0)
    );
};

export enum ProductAvailabilityStatus {
    InStock = "in-stock",
    S2S = "s2s",
    LowStock = "low-stock",
    NoStock = "no-stock"
}

export const getProductAvailabilityStatus = (
    productAvailability: CloudProductAvailability
) => {
    if (
        productAvailability?.deliveryPromiseType ===
        CloudDeliveryPromiseType.AvailableForS2S
    ) {
        return ProductAvailabilityStatus.S2S;
    } else if (
        !productAvailability?.realTimeStockAvailable &&
        productAvailability?.stockLevel === CloudStockLevel.LowStock
    ) {
        return ProductAvailabilityStatus.LowStock;
    } else if (
        (!productAvailability?.realTimeStockAvailable &&
            productAvailability?.stockLevel === CloudStockLevel.NoStock) ||
        (!productAvailability?.realTimeStockAvailable &&
            productAvailability?.stockLevel === null) ||
        (productAvailability?.realTimeStockAvailable &&
            productAvailability?.realTimeStock! <= 0)
    ) {
        return ProductAvailabilityStatus.NoStock;
    } else {
        return ProductAvailabilityStatus.InStock;
    }
};
